import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicShareResolver } from './public-share/public-share-resolver.service';
import { AuthGuard } from './core/guards';
import { LoginViaJwtFirstGuard } from './core/guards';

const routes: Routes = [
  {
    path: '',
    canActivate: [LoginViaJwtFirstGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./order-steppers/create-order.module').then(m => m.CreateOrderModule)
      },
      {
        path: 'notary-services',
        loadChildren: () => import('./notary-services/notary-services.module').then(m => m.NotaryServicesModule)
      },
      {
        path: 'profile',
        loadChildren: () => import('./client-space/profile/profile.module').then(m => m.ProfileModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'listing',
        loadChildren: () =>
          import('./client-space/listing-notaire-stats/listing-notaire/listing-notaire.module').then(
            m => m.ListingNotaireModule
          ),
        canActivate: [AuthGuard]
      },
      {
        path: 'stats',
        loadChildren: () => import('./client-space/listing-notaire-stats/stats/stats.module').then(m => m.StatsModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'public/:orderid',
        resolve: { order: PublicShareResolver },
        loadChildren: () => import('./public-share/public-share.module').then(m => m.PublicShareModule)
      },
      {
        path: 'checkout',
        loadChildren: () => import('./checkout/checkout.module').then(m => m.CheckoutModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'customer',
        loadChildren: () => import('./client-space/client-space.module').then(m => m.ClientSpaceModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'site',
        loadChildren: () => import('./website/website.module').then(m => m.WebsiteModule)
      },
      { path: 'qr/:qrid', loadChildren: () => import('./qr-code/qr-code.module').then(m => m.QrCodeModule) },
      {
        path: 'comissions',
        loadChildren: () => import('./client-space/comissions/commissions.module').then(m => m.CommissionsModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'order-feedback',
        loadChildren: () => import('./order-feedback/order-feedback.module').then(m => m.OrderFeedbackModule)
      },
      {
        path: 'order-anonymous-schedule',
        loadChildren: () =>
          import('./order-anonymous-schedule/order-anonymous-schedule.module').then(m => m.OrderAnonymousScheduleModule)
      },
      {
        path: 'order-create-and-schedule',
        loadChildren: () =>
          import('./order-create-and-schedule/order-create-and-schedule.module').then(
            m => m.OrderCreateAndScheduleModule
          ),
        canActivate: [AuthGuard]
      }
    ]
  },
  { path: '**', redirectTo: '/' }
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule],
  providers: [PublicShareResolver]
})
export class AppRoutingModule {}
